var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/logo-rryb.png")}}),_c('button',{staticClass:"link",on:{"click":_vm.agreement}},[_vm._v("查看《用户协议》")])])
}
var staticRenderFns = []

export { render, staticRenderFns }